import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const ConfirmContext = createContext();
const ConfirmContextProvider = ({ children }) => {
  const [confirm, setConfirm] = useState({
    isOpen: false,
    nextTab: null,
    proceed: null,
    cancel: null,
  });

  return (
    <ConfirmContext.Provider value={[confirm, setConfirm]}>
      {children}
    </ConfirmContext.Provider>
  );
};
ConfirmContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default ConfirmContextProvider;
